const createV2VformSubmitButtonElement = () => {
  const el = document.createElement('input')
  el.type = 'button'
  el.value = '次のステップに進む'
  el.classList.add('v2-vform-submit')

  return el
}

const scrollToTop = () => {
  window.scrollTo(0, 0)
}

const reportValidity = (el: HTMLDivElement) => {
  const targets = el.querySelectorAll<HTMLInputElement|HTMLSelectElement|HTMLTextAreaElement>('input, select, textarea')

  return Array.from(targets).every(target => target.reportValidity())
}

// step1の制約検証を行い、問題がなければstep2へ進む
const onStep1Submit = (step1El: HTMLDivElement, step2El: HTMLDivElement) => {
  const step1Valid = reportValidity(step1El)
  if (!step1Valid) {
    return
  }

  step2El.hidden = false
  step1El.hidden = true
  scrollToTop()
}

const main = (step1El: HTMLDivElement, step2El: HTMLDivElement) => {
  step2El.hidden = true

  const step1SubmitButton = createV2VformSubmitButtonElement()
  step1SubmitButton.addEventListener('click', () => onStep1Submit(step1El, step2El))
  step1El.appendChild(step1SubmitButton)
}

document.addEventListener('DOMContentLoaded', () => {
  const step1El = document.querySelector<HTMLDivElement>('div.js-registration-wizard-step1')
  const step2El = document.querySelector<HTMLDivElement>('div.js-registration-wizard-step2')
  if (step1El && step2El) {
    main(step1El, step2El)
  }
});
